import { render, staticRenderFns } from "./BreakoutHistory.vue?vue&type=template&id=30a2b6d4"
import script from "./BreakoutHistory.vue?vue&type=script&lang=js"
export * from "./BreakoutHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports